
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'

import { defineComponent, h, PropType, reactive, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ExaminationDetailService } from './examination-detail.service'
const SIZE_MB = 1024
const SIZE_GB = SIZE_MB * SIZE_MB

export interface BaseInfo {
  score: number
  user_mark: string
  group_name: string
  device_id: string
}

export default defineComponent({
  props: {
    baseInfo: {
      type: Object as PropType<BaseInfo>,
      default: () => { return {} }
    },
    groupId: {
      type: Number,
      default: -1
    }
  },
  emits: ['closeDrawer'],
  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector()
    const examinationService = injector.get(ExaminationDetailService as Type<ExaminationDetailService>)
    const drawerOptions = reactive<{
      baseInfo: BaseInfo,
      groupId: number,
      exam_detail: any
    }>({
      baseInfo: props.baseInfo as BaseInfo,
      groupId: props.groupId as number,
      exam_detail: {
        garbage: {},
        speed: {},
        guard: {},
        system: {},
        soft: {},
        virus: {},
      }
    })
    function fetchData () {
      examinationService.fetchExaminationDetails(drawerOptions.baseInfo.device_id).then(res => {
        drawerOptions.exam_detail = res
      })
    }
    fetchData()
    watch(() => props.baseInfo, () => {
      fetchData()
    })
    return {
      drawerOptions,
      calcFileSize (size: number) {
        return size < SIZE_MB ? size + 'K' : (size < SIZE_GB ? (size / SIZE_MB).toFixed(1) + 'M' : (size / SIZE_GB).toFixed(1) + 'G')
      },
      calcScoreColor (score: number): string {
        // eslint-disable-next-line no-magic-numbers
        return score ? (score > 79 ? 'green-score' : (score > 60 ? 'yellow-score' : 'red-score')) : 'zero-score'
      },
      repairSingleTerminal () {
        ElMessageBox({
          title: t('safeProtectionModule.tip'),
          showCancelButton: true,
          message: h('div', { style: 'display:flex;align-items:center;margin-left:10px;margin-top:25px;margin-bottom:20px' }, [
            h(CmSvgIcon, { name: 'views/dashboard/_components/examination/_images/client_modal_tip', size: 40,color: "var(--cm-color-primary)", monochrome: true,style:'width: 40px;height:40px;color:var(--cm-color-primary)' }),
            h('div', { style: 'margin-left:10px;flex:auto' }, [
              h('p', null, t('examinationTable.repairDispatchLine1', { n: 1 })),
              h('p', null, `2. ${t('safeProtectionModule.virusScanModalLine2')}`)
            ])
          ]),
          confirmButtonText: t('common.confirm'),
          cancelButtonText: t('common.cancel'),
        }).then(() => {
          examinationService.repairTerminal({
            execute_type: 0,
            device_list: [(props.baseInfo as BaseInfo).device_id],
            group_id: props.groupId as number,
            is_repair: true
          }).then(() => {
            ElMessage.success(t('examinationTable.repairDispatchSuccess', { n: 1 }))
            context.emit('closeDrawer')
          }).catch(() => {
            ElMessage.error(t('examinationTable.repairDispatchFail', { n: 1 }))
            context.emit('closeDrawer')
          })
        })
      },
    }
  }
})
